$(function () {

  // Cat images
  GLOBAL.initCatItems = function (item, verticalThumbs) {
    var $ciGalleryMainContainer = $('.cat-item-image .swiper-container', item),
        $ciGalleryThumbs = $('.cat-item-thumbs', item),
        $ciGalleryThumbsContainer = $('.swiper-container', $ciGalleryThumbs),
        $ciGalleryThumbsWrapper = $('.swiper-wrapper', $ciGalleryThumbs),
        $ciGalleryThumbsLinks = $('a', $ciGalleryThumbs);

    if ($ciGalleryThumbs.length) {
      if ($(item).data('initialized')) {
        $ciGalleryMainContainer.get(0).swiper.destroy();
        if (!GLOBAL.isTouchscreen) {
          $ciGalleryThumbsContainer.get(0).swiper.destroy();
          $ciGalleryThumbs.find('img').off('load.gallery');
          $ciGalleryThumbsLinks.off('click.gallery');
        }
      }

      // Main image gallery
      var ciGalleryMain = new Swiper($ciGalleryMainContainer, {
        allowTouchMove: GLOBAL.isTouchscreen,
        effect: 'cube',
        cubeEffect: {
          slideShadows: false,
          shadow: false
        }
      });

      if (!GLOBAL.isTouchscreen) {
        // Thumbs gallery
        var ciGalleryThumbs = new Swiper($ciGalleryThumbsContainer, {
          direction: verticalThumbs ? 'vertical' : 'horizontal',
          spaceBetween: verticalThumbs ? 2 : 0,
          slidesPerView: 'auto'
        });
        $ciGalleryThumbs.find('img').on('load.gallery', function () {
          if ((verticalThumbs ? $ciGalleryThumbsWrapper.height() : $ciGalleryThumbsWrapper.width()) <= (verticalThumbs ? $ciGalleryThumbsContainer.height() : $ciGalleryThumbsContainer.width())) {
            ciGalleryThumbs.allowTouchMove = false;
          } else {
            ciGalleryThumbs.mousewheel.enable();
          }
        }).each(function () {
          if (this.complete) {
            $(this).trigger('load.gallery');
          }
        });
        ciGalleryMain.controller.control = ciGalleryThumbs;
        $ciGalleryThumbsLinks.on('click.gallery', function (e) {
          e.preventDefault();
          $ciGalleryThumbsLinks.parent().removeClass('active');
          $(this).parent().addClass('active');
          ciGalleryMain.slideTo($ciGalleryThumbsLinks.index(this));
        });
        $ciGalleryThumbsLinks.first().trigger('click');
      }
    }

    // Zoomer
    if (!GLOBAL.isTouchscreen && !$(item).data('initialized')) {
      $(item).find('.cat-item-image .swiper-slide').each(function () {
        var self = this;
        $(this).zoom({
          url: $(self).find('img').data('big-src')
        });
      });
    }

    $(item).data('initialized', true);
  };




  // Responsive
  GLOBAL.actualResizer = 'throttledresize' in jQuery.event.special ? 'throttledresize' : 'resize';
  function responsiveFixes() {
    var ww = $(window)[0].innerWidth || $(window).width(),
        wh = $(window)[0].innerHeight || $(window).height();

    GLOBAL.windowSize = [ww, wh];

    // Prevent fixes if changed only window height
    if ($(document.body).data('originalWW') && $(document.body).data('originalWW') == ww) {
      return;
    }
    $(document.body).data('originalWW', ww);

    if (ww < 1698) {
      $('.cat-item').each(function () {
        $('.cat-item-thumbs', this).insertAfter($('.cat-item-image', this));
        if ($(this).parents('.tabs-container').is(':visible') || !!$(this).attr('id')) {
          GLOBAL.initCatItems(this);
        }
      });
    } else {
      $('.cat-item').each(function () {
        $('.cat-item-thumbs', this).insertBefore($('.cat-item-main', this));
        if ($(this).parents('.tabs-container').is(':visible') || !!$(this).attr('id')) {
          GLOBAL.initCatItems(this, true);
        }
      });
    }

    // Responsive menu
    // Required: /js/plugins/jquery.event.move.js, /js/plugins/jquery.event.swipe.js
    $('.mobile-menu-link').off('click.ht');
    $('nav').off('.ht');
    $('nav .nav-inner-menu').hide().prev().removeClass('hovered');
    // <@{max-width-base}px (taking into account @reduction-ratio)
    if (ww < 1469 * .8) {
      $('nav .nav-menu-container').addClass('popup popup-menu');
      $('nav .nav-inner-menu').removeClass('popup popup-menu');
      $('.mobile-menu-link').on('click.ht', function (e) {
        e.preventDefault();
        $(document.body).toggleClass('nav-opened');
      });
      $('.nav-menu-container').on('swipeleft.ht', function () {
        $('.mobile-menu-link').trigger('click');
      }).on('movestart.ht', function (e) {
        if ((e.distX > e.distY && e.distX < -e.distY) || (e.distX < e.distY && e.distX > -e.distY)) {
          e.preventDefault();
        }
      });

      $('.header-top').before($('.slogan'));
      if (!$('.footer-contacts').length) {
        $('footer > .wrapper > *:not(.logo)').wrapAll($('<div class="footer-contacts" />'));
      }
    } else {
      $('nav .nav-menu-container').removeClass('popup popup-menu');
      $('nav .nav-inner-menu').addClass('popup popup-menu');

      $('.header-top').after($('.slogan'));
      $('footer > .wrapper').append($('.footer-contacts > *')).find('.footer-contacts').remove();
    }

    if (ww < 420) {
      $('.form-search .input').attr('placeholder', 'поиск...');
      $('#cx3f-price-organization').attr('placeholder', 'Ваша организация');
    } else {
      $('.form-search .input').attr('placeholder', 'поиск по сайту...');
      $('#cx3f-price-organization').attr('placeholder', 'Какую организацию вы представляете?');
    }
  }
  responsiveFixes();
  $(window).on(GLOBAL.actualResizer, responsiveFixes);




  // Replace checkboxes and radio buttons
  // Required: /js/src/plugins/jquery.inputs.js
  if (GLOBAL.config.inputs.length) {
    GLOBAL.config.inputs.inputs();
  }


  // Replace selectors
  // Required: /js/src/plugins/jquery.stylish-select.js
  if (GLOBAL.config.selectors.length) {
    GLOBAL.config.selectors.sSelect();
  }


  // Carousels
  // Required: /js/src/plugins/jquery.jcarousel.js
  // Optional: /js/src/plugins/jcarousel-plugins/jquery.jcarousel-swipe.js, /js/src/plugins/jcarousel-plugins/jquery.jcarousel-fade.js
  var carouselInit = function (container, options) {
    var
      $carousel = $('.jcarousel-wrapper', container).jcarousel({
        wrap: options.wrap,
        vertical: options.vertical
      }),
      isFadeSupported = $.isFunction($.jcarousel.fn.fade),
      method = isFadeSupported && options.method == 'fade' ? 'fade' : 'scroll';

    $carousel.jcarouselAutoscroll({
      interval: options.autoscrollInterval,
      target: '+=' + options.scrollableItems,
      autostart: !!options.autoscrollInterval,
      method: method // 'fade' not supported here (https://github.com/jsor/jcarousel/issues/806)
    });

    $('.jcarousel-prev', container).on('jcarouselcontrol:active', function () {
      $(this).removeClass('jcarousel-controls-inactive');
    }).on('jcarouselcontrol:inactive', function () {
      $(this).addClass('jcarousel-controls-inactive');
    }).jcarouselControl({
      target: '-=' + options.scrollableItems,
      method: method
    });
    $('.jcarousel-next', container).on('jcarouselcontrol:active', function () {
      $(this).removeClass('jcarousel-controls-inactive');
    }).on('jcarouselcontrol:inactive', function () {
      $(this).addClass('jcarousel-controls-inactive');
    }).jcarouselControl({
      target: '+=' + options.scrollableItems,
      method: method
    });

    if (options.pagination && $carousel.jcarousel('items').length > options.scrollableItems) {
      $('.jcarousel-pagination', container).on('click', function (e) {
        e.preventDefault();
      }).on('jcarouselpagination:active', 'a', function () {
        $(this).addClass('jcarousel-pagination-active');
      }).on('jcarouselpagination:inactive', 'a', function () {
        $(this).removeClass('jcarousel-pagination-active');
      }).jcarouselPagination({
        'item': function (page, carouselItems) {
          return '<a href="">' + page + '</a>';
        },
        method: method
      });
    }

    if ('jcarouselSwipe' in $carousel && options.touchable) {
      var touchConfig = {};
      if (isFadeSupported) {
        touchConfig = {
          draggable: false,
          method: method
        };
      }
      $carousel.jcarouselSwipe(touchConfig);
    }
  };

  $.each(GLOBAL.config.carousels, function (selector, options) {
    if ($(selector).length > 1) {
      $(selector).each(function () {
        carouselInit(this, options);
      });
    } else {
      carouselInit(selector, options);
    }
  });


  // Modal windows
  // Required: /js/src/plugins/jquery.uniloader.js
  var modalInit = function (activator, options) {
    var opts = {};
    if ($(activator).data('modal-node')) {
      opts.node = $(activator).data('modal-node');
    }
    $.overlayLoader(true, $.extend(true, {}, opts, $(activator).data('modal-options') || options));
  };

  for (var i in GLOBAL.config.modals) {
    $(i).data('modal-options', GLOBAL.config.modals[i]).on('click', function (e) {
      e.preventDefault();
      modalInit(this);
    });
  }


  // Popups
  // Required: /js/src/plugins/jquery.unifloat.js
  var popupHandler = function (activator, options) {
    if (!$(activator).length) {
      return;
    }
    var options = options || $(activator).data('popup-options');
    var target = options.rel || '#' + $(activator).attr('id') + '-content',
        self = activator;
    if (options.manipulation && !$(target).data('unifloat-manipulated')) {
      $(document.body).append($(target));
      $(target).data('unifloat-manipulated', true);
    }
    if ($(target).is(':hidden')) {
      $(target).unifloat('show', $.extend(true, {}, options, {
        rel: self
      })).data('unifloat-source', activator);
    } else {
      $(target).hide();
      if (options.onHide) {
        options.onHide(self, target);
      }
    }
  };

  for (var i in GLOBAL.config.popups) {
    $(i).data('popup-options', GLOBAL.config.popups[i]).on('click', function (e) {
      e.preventDefault();
      popupHandler(this);
    });
  }

  // Close popups (modal windows supported)
  // By clicking on an empty area of the window
  $(document.body).on('click', function (e) {
    var isPopup = false;
    $('.popup-activator, .popup, #overlay, .modal').each(function () {
      if ($(e.target).is(this) || $(e.target).parents().is(this)) {
        isPopup = true;
      }
    });
    if ($(e.target).is('.popup-activator') && $(e.target).parents().is('.popup')) {
      $('.popup:visible').each(function () {
        popupHandler($(this).data('unifloat-source'));
      });
      popupHandler(e.target);
      return;
    }
    if (isPopup) {
      return;
    } else {
      $('.popup:visible').each(function () {
        popupHandler($(this).data('unifloat-source'));
      });
    }
  });
  // By close button
  $('.popup-close').not('.modal-close').on('click', function (e) {
    e.preventDefault();
    $(document.body).trigger('click');
  });


  // Tabs
  // Required: /js/src/plugins/jquery.easytabs.js
  $.each(GLOBAL.config.tabs, function (selector, options) {
    if ($(selector).length > 1) {
      $(selector).each(function () {
        $(this).easytabs(options);
      });
    } else {
      $(selector).easytabs(options);
    }

    $('#showcase').bind('easytabs:after', function(e, link, target, settings) {
      $(target).find('.cat-item').each(function () {
        if (GLOBAL.windowSize[0] < 1698) {
          GLOBAL.initCatItems(this);
        } else {
          GLOBAL.initCatItems(this, true);
        }
      });
    });
  });


  // Forms errors processing
  var inputs = '.input, select, textarea, .SSContainerDivWrapper',
      defaultValues = ['', 0];

  var $formErrors = $('.form .form-error');
  if ($formErrors.length) {
    setInterval(function () {
      $formErrors.find(inputs).each(function () {
        var $par = $(this).hasClass('SSContainerDivWrapper') ? $(this).parent().parent() : $(this).parent(),
            val = $(this).hasClass('SSContainerDivWrapper') ? $(this).parent().prev().val() : $(this).val(),
            activeState = $(this).hasClass('SSContainerDivWrapper') ? $(this).is(':visible') : $(this).is(':focus');
        if (activeState) {
          $par.data('wasError', true);
          $par.removeClass('form-error');
        } else {
          if ($par.data('wasError')) {
            $par.removeClass('form-error');
            if ($.inArray(val, defaultValues) != -1) {
              $par.addClass('form-error');
            }
          }
        }
      });
    }, 111);
  }




  // Custom scripts

  // Submenu
  if (GLOBAL.isTouchscreen) {
    $('nav .nav-menu > li > a i').on('click', function (e) {
      e.preventDefault();
      $(this).parent().toggleClass('hovered').next().slideToggle();
    });
  } else {
    $('nav .nav-menu > li > a[id]').unifloat({
      posTop: {
        auto: false
      },
      posLeft: {
        value: 10,
        auto: false
      },
      manipulation: false,
      onShow: function (s, t) {
        $(s).addClass('hovered');
      },
      onHide: function (s, t) {
        $(s).removeClass('hovered');
      }
    });
  }

  // Main rotator
  var mainRotator = '#main',
      mainRotatorConfig = {};
  if ($('.swiper-slide', mainRotator).length > 1) {
    mainRotatorConfig = {
      loop: true,
      autoplay: {
        delay: 10000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: $('.swiper-button-next', mainRotator),
        prevEl: $('.swiper-button-prev', mainRotator)
      },
      pagination: {
        el: $('.swiper-pagination', mainRotator),
        clickable: true
      }
    };
  }
  var rotator = new Swiper($('.swiper-container', mainRotator), mainRotatorConfig);

  // Animations by scroll
  $('.advantages li').viewportChecker({
    classToAdd: 'fadeInUp',
    repeat: false
  });
  $('.delivery li').viewportChecker({
    repeat: false
  });

  // Privacy
  $('#privacy').on('click', function () {
    if ($(this).is(':checked')) {
      $('.form-submit input').removeAttr('disabled');
    } else {
      $('.form-submit input').attr('disabled', 'disabled');
    }
  });

  // Colorbox
  $('.colorbox').colorbox({
    scrolling: false,
    maxWidth: '90%',
    maxHeight: '90%',
    opacity: .75
  });
});